import { render, staticRenderFns } from "./NovelCard.vue?vue&type=template&id=7e977286&scoped=true"
import script from "./NovelCard.vue?vue&type=script&lang=js"
export * from "./NovelCard.vue?vue&type=script&lang=js"
import style0 from "./NovelCard.vue?vue&type=style&index=0&id=7e977286&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e977286",
  null
  
)

export default component.exports